import PropTypes from 'prop-types';
import { memo } from 'react';
import ReactDOM from 'react-dom';
import { LightBoxWrapper } from './LightBoxWrapper.js';
import { FullCart } from './FullCart.js';

export let FullCartLightbox = function ({ showFullCartMessage, setShowFullCartMessage, portalTarget }) {
    if (!showFullCartMessage) {
        return null;
    }

    const unmountHandler = () => setShowFullCartMessage(false);
    const lightbox = (
        <LightBoxWrapper unMountHandler={unmountHandler}>
            <FullCart fullPage={false} />
        </LightBoxWrapper>
    );

    // If a caller explicitly passed a portalTarget, and its value turned out to be null, that *probably* means
    // the caller messed up their use of `ref`. Explicitly warn about that.
    if (portalTarget === null) {
        console.error(
            'Null portalTarget passed into FullCartLightbox! Check for a broken ref. ' +
            'If you don\'t need to use Portals, just leave portalTarget undefined instead.',
        );
    }

    // We need to portal out of ProjectCard because it's an <a />.
    // We *don't* want to portal out of other use cases (like fullCartHandlerMain).
    if (portalTarget != null) {
        return ReactDOM.createPortal(
            lightbox,
            portalTarget,
        );
    } else {
        return lightbox;
    }
};
FullCartLightbox.propTypes = {
    showFullCartMessage: PropTypes.bool.isRequired,
    setShowFullCartMessage: PropTypes.func.isRequired,
    // See documentation in giveWidget.js
    portalTarget: PropTypes.instanceOf(window.Element),
};
FullCartLightbox = memo(FullCartLightbox);
